import React from 'react';
import { Button, Form, Input } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { InputInterface } from '../../utils/forms/FormInterface';

interface DynamicPackagesInputProps {
  formInput: InputInterface;
  index: number;
  form: any;
  isCreateMode?: boolean;
}

const DynamicPackagesInput: React.FC<DynamicPackagesInputProps> = props => {
  const { formInput, index, form: _form } = props;

  return (
    <Form.List key={index} name={formInput.name}>
      {(fields, { add, remove }, { errors }) => (
        <>
          {fields.map(({ key, name, ...restField }, fieldIndex) => (
            <div
              key={key}
              style={{
                margin: '16px',
                border: '1px solid #d9d9d9',
                padding: '16px',
                borderRadius: '4px',
                backgroundColor: '#fafafa',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '12px',
                }}
              >
                <h4 style={{ margin: 0 }}>Package {fieldIndex + 1}</h4>
                {fields.length > 1 && (
                  <Button
                    type="text"
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => remove(name)}
                    style={{ marginBottom: '8px' }}
                  >
                    Remove Package
                  </Button>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <Form.Item
                  {...restField}
                  name={[name, 'packageName']}
                  label="Package Name"
                  rules={[{ required: true, message: 'Please enter package name' }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input placeholder="e.g., New OCI Application" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'packageUrl']}
                  label="Package URL"
                  rules={[{ required: true, message: 'Please enter package URL' }]}
                  style={{ marginBottom: 0 }}
                >
                  <Input placeholder="e.g., /package/oci-services/new-oci" />
                </Form.Item>
              </div>
            </div>
          ))}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
              style={{ width: 'fit-content' }}
            >
              Add Package
            </Button>
          </Form.Item>
          {errors && errors.length > 0 && (
            <div style={{ color: 'red', marginTop: '8px' }}>
              {errors.map((error, idx) => (
                <div key={idx}>{error}</div>
              ))}
            </div>
          )}
        </>
      )}
    </Form.List>
  );
};

export default DynamicPackagesInput;
